import React from 'react';
import {Navigate, useLocation} from 'react-router-dom';
import {connect} from 'react-redux';

import LoadingSpinner from "../components/LoadingSpinner";

const CanCreateProject = ({children, user}) => {
    const location = useLocation();
    if (user === null) {
        return <LoadingSpinner/>
    }
    return (!user?.last_name || !user?.first_name || !user?.title || user?.avatar == null) ? <Navigate to='/account/project' state={{from: location}} replace={true}/> : children;
}

const mapStateToProps = state => ({
    user: state.auth.user,
});

export default connect(mapStateToProps)(CanCreateProject);